module.exports = __webpack_public_path__ + "img/矩形 30 拷贝@2x.cd93ccb9.png";